// app/components/StatusPage.tsx
import React from 'react';

interface StatusPageProps {
  icon: React.ReactNode;
  title: string;
  message: React.ReactNode; // Peut maintenant être du JSX pour plus de flexibilité
  actions?: React.ReactNode;
}

const StatusPage = ({ icon, title, message, actions }: StatusPageProps) => {
  return (
    <div className="text-center p-8 sm:p-12 bg-white shadow-2xl rounded-2xl max-w-xl mx-auto animate-fade-in-up border border-gray-100">
      <div className="mx-auto flex justify-center mb-6">{icon}</div>
      <h1 className="text-4xl font-extrabold text-gray-800 mb-4">{title}</h1>
      <div className="text-gray-600 text-lg space-y-4 mb-8">{message}</div>
      {actions && (
        <div className="mt-8 flex justify-center gap-4">{actions}</div>
      )}
    </div>
  );
};

export default StatusPage;
